import React from "react";

const EnrolledShimmer = () => {
  return (
    <>
      <div className="overflow-hidden flex flex-row items-center  gap-2 w-full relative space-y-5 rounded-2xl bg-richblack-900 border-3 border-richblack-800 bg-gradient-to-r from-transparent via-richblack-800 to-transparent p-4 shadow-xl shadow-black/5 before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1s_infinite] before:border-t before:border-richblack-900 before:bg-gradient-to-r before:from-transparent before:via-richblack-900 before:to-transparent">
        <div className="h-16 w-[20%] rounded-lg bg-richblack-700 "></div>
        <div className="flex flex-col w-full gap-2 pb-3 ">
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
        </div>
      </div>
      <div className="overflow-hidden flex flex-row items-center  gap-2 w-full relative space-y-5 rounded-2xl bg-richblack-900 border-3 border-richblack-800 bg-gradient-to-r from-transparent via-richblack-800 to-transparent p-4 shadow-xl shadow-black/5 before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1s_infinite] before:border-t before:border-richblack-900 before:bg-gradient-to-r before:from-transparent before:via-richblack-900 before:to-transparent">
        <div className="h-16 w-[20%] rounded-lg bg-richblack-700 "></div>
        <div className="flex flex-col w-full gap-2 pb-3 ">
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
        </div>
      </div>
      <div className="overflow-hidden flex flex-row items-center  gap-2 w-full relative space-y-5 rounded-2xl bg-richblack-900 border-3 border-richblack-800 bg-gradient-to-r from-transparent via-richblack-800 to-transparent p-4 shadow-xl shadow-black/5 before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1s_infinite] before:border-t before:border-richblack-900 before:bg-gradient-to-r before:from-transparent before:via-richblack-900 before:to-transparent">
        <div className="h-16 w-[20%] rounded-lg bg-richblack-700 "></div>
        <div className="flex flex-col w-full gap-2 pb-3 ">
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
          <div className="h-3 w-[70%]  rounded-md bg-richblack-700"></div>
        </div>
      </div>
    </>
  );
};

export default EnrolledShimmer;
